import React from "react";
import FilterDropdown from "../dropdowns/filter-dropdown.jsx";
import { MaterialMenu, MaterialMenuTwo, MaterialMenuFour } from "../dropdowns/menus.jsx";
import { SelectedFilters } from "../dropdowns/selected-filters.jsx";

function toImagePath(imagepath) {
  if (!imagepath) return "";
  return imagepath.replace("\\Jola_Fabrics\\", "").replace(/\\/g, "/");
}

function filterBlank(arr) {
  if (!arr) return [];
  return arr.filter(function (v) { return v && v.trim() !== ""; });
}

class SwatchImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { imgError: false };
    this.imgRef = null;
    this.handleImageError = this.handleImageError.bind(this);
  }

  handleImageError() {
    this.setState({ imgError: true });
  }

  componentDidMount() {
    if (this.imgRef && this.imgRef.complete && this.imgRef.naturalHeight === 0) {
      this.handleImageError();
    }
  }

  render() {
    if (this.state.imgError) {
      return (
        <div className="configure-swatch-image">
          <div className="gallery-item-placeholder"><image-placeholder></image-placeholder></div>
        </div>
      );
    }
    return (
      <div className="configure-swatch-image">
        <img ref={(el) => { this.imgRef = el; }} src={this.props.src} alt={this.props.alt} onError={this.handleImageError} />
      </div>
    );
  }
}

export default class ConfigureComponent extends React.Component {
  constructor(props) {
    super(props);
    // PDP lazy-load (2026-08-21): configuration is no longer an SSR prop
    // (it made every PDP ~2.2 MB). It's fetched from
    // /api/Product/Configuration/{sku} on first modal open and kept in
    // state.config; getConfig() is the single accessor.
    this.FABRIC_PAGE_SIZE = 60;
    this.storageKey = "configure-" + (props.sku || "");
    var saved = this.loadSelections();
    this.state = {
      visible: false,
      config: null,
      configLoading: false,
      configError: false,
      activeTab: "",
      searchQuery: "",
      searchShowCancel: false,
      filters: { collection: [], grade: [], pattern: [], color: [] },
      fabricSelections: saved.fabricSelections || {},
      selectedFinish: saved.selectedFinish || null,
      selectedOptions: saved.selectedOptions || {},
      additionalOptions: saved.additionalOptions || {},
      showAdditionalFabrics: false,
      activeApplicationArea: null,
      fabricDisplayCount: this.FABRIC_PAGE_SIZE,
      saving: false,
      confirmed: false,
      showSummary: false,
      mobileFilterOpen: false,
    };
    this.tabContentRef = null;
    this.open = this.open.bind(this);
    this.close = this.close.bind(this);
    this.onOverlayClick = this.onOverlayClick.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onTabContentScroll = this.onTabContentScroll.bind(this);
    this.openMobileFilter = this.openMobileFilter.bind(this);
    this.closeMobileFilter = this.closeMobileFilter.bind(this);
  }

  getConfig() {
    return this.state.config || {};
  }

  loadConfiguration() {
    if (this.state.config || this.state.configLoading) return;
    var self = this;
    this.setState({ configLoading: true, configError: false });
    fetch("/api/Product/Configuration/" + encodeURIComponent(this.props.sku || ""))
      .then(function (r) {
        if (!r.ok) throw new Error("HTTP " + r.status);
        return r.json();
      })
      .then(function (cfg) {
        var tabs = self.buildTabs(cfg || {});
        self.setState({
          config: cfg || {},
          configLoading: false,
          activeTab: tabs.length > 0 ? tabs[0].key : ""
        });
      })
      .catch(function () {
        self.setState({ configLoading: false, configError: true });
      });
  }

  openMobileFilter() {
    this.setState({ mobileFilterOpen: true });
  }

  closeMobileFilter() {
    this.setState({ mobileFilterOpen: false });
  }

  // --- sessionStorage helpers ---

  loadSelections() {
    if (typeof sessionStorage === "undefined") return {};
    try {
      var raw = sessionStorage.getItem(this.storageKey);
      return raw ? JSON.parse(raw) : {};
    } catch (e) {
      return {};
    }
  }

  saveSelections(partial) {
    if (typeof sessionStorage === "undefined") return;
    var current = this.loadSelections();
    var merged = Object.assign({}, current, partial);
    try {
      sessionStorage.setItem(this.storageKey, JSON.stringify(merged));
    } catch (e) { /* quota exceeded — ignore */ }
  }

  clearSelections() {
    if (typeof sessionStorage === "undefined") return;
    sessionStorage.removeItem(this.storageKey);
  }

  buildTabs(config) {
    var tabs = [];
    if (config.fabrics) {
      tabs.push({ key: "fabric", label: config.fabrics.name || "Fabric Options" });
    }
    if (config.finishes) {
      tabs.push({ key: "finish", label: config.finishes.name || "Finish Options" });
    }
    var options = config.options || [];
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (!opt.isAdditionalOption) {
        tabs.push({ key: "custom-" + i, label: opt.name, optionIndex: i });
      }
    }
    var hasAdditional = options.some(function (o) { return o.isAdditionalOption; });
    if (hasAdditional) {
      tabs.push({ key: "additional", label: "Additional Options" });
    }
    return tabs;
  }

  componentDidMount() {
    if (typeof document === "undefined") return;
    var btn = document.querySelector(".ui-button-configure");
    if (!btn) return;
    if (!this.props.isConfigurable) {
      btn.innerHTML = 'Add To Quote Request';
      btn.classList.remove("ui-button-configure");
      btn.classList.add("ui-button-quote-request");
      this._directQuoteHandler = function (e) {
        e.preventDefault();
        this.addToQuoteRequest();
      }.bind(this);
      btn.addEventListener("click", this._directQuoteHandler);
    } else {
      btn.addEventListener("click", this.open);
    }
  }

  componentWillUnmount() {
    if (typeof document === "undefined") return;
    var btn = document.querySelector(".ui-button-configure");
    var quoteBtn = document.querySelector(".ui-button-quote-request");
    if (btn) {
      btn.removeEventListener("click", this.open);
    }
    if (quoteBtn && this._directQuoteHandler) {
      quoteBtn.removeEventListener("click", this._directQuoteHandler);
    }
    document.removeEventListener("keydown", this.onKeyDown);
  }

  open() {
    this.setState({ visible: true });
    this.loadConfiguration();
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", this.onKeyDown);
  }

  close() {
    this.setState({ visible: false });
    document.body.style.overflow = "";
    document.removeEventListener("keydown", this.onKeyDown);
  }

  onOverlayClick(e) {
    if (e.target === e.currentTarget) {
      this.close();
    }
  }

  onKeyDown(e) {
    if (e.key === "Escape") {
      this.close();
    }
  }

  onTabContentScroll(e) {
    // On desktop the .configure-tab-content scrolls; on mobile (≤768px)
    // overflow:visible bumps scrolling up to .configure-modal. Use the
    // event's currentTarget so the same handler works on either element.
    var el = e && e.currentTarget ? e.currentTarget : this.tabContentRef;
    if (!el) return;
    if (el.scrollTop + el.clientHeight >= el.scrollHeight - 200) {
      this.setState(function (prev) {
        return { fabricDisplayCount: prev.fabricDisplayCount + 60 };
      });
    }
  }

  setTab(tab) {
    this.setState({ activeTab: tab, searchQuery: "", searchShowCancel: false, fabricDisplayCount: this.FABRIC_PAGE_SIZE, showSummary: false });
    if (this.tabContentRef) this.tabContentRef.scrollTop = 0;
    if (this.modalRef) this.modalRef.scrollTop = 0;
  }

  onSearchChange(e) {
    var value = e.target.value;
    this.setState({ searchQuery: value, searchShowCancel: value.length > 0, fabricDisplayCount: this.FABRIC_PAGE_SIZE });
  }

  onSearchCancel() {
    this.setState({ searchQuery: "", searchShowCancel: false, fabricDisplayCount: this.FABRIC_PAGE_SIZE });
  }

  toggleFilterValue(key, value) {
    this.setState(function (prev) {
      var arr = prev.filters[key];
      var idx = arr.indexOf(value);
      var next = idx === -1 ? arr.concat([value]) : arr.filter(function (v) { return v !== value; });
      var filters = {};
      for (var k in prev.filters) filters[k] = prev.filters[k];
      filters[key] = next;
      return { filters: filters, fabricDisplayCount: 60 };
    });
  }

  getSelectedChips() {
    var chips = [];
    var filters = this.state.filters;
    var keys = ["collection", "grade", "pattern", "color"];
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var arr = filters[key];
      for (var j = 0; j < arr.length; j++) {
        chips.push({ id: key + ":" + arr[j], filterKey: key, value: arr[j], label: arr[j] });
      }
    }
    return chips;
  }

  removeChip(chip) {
    this.toggleFilterValue(chip.filterKey, chip.value);
  }

  clearAllFilters() {
    this.setState({ filters: { collection: [], grade: [], pattern: [], color: [] }, fabricDisplayCount: this.FABRIC_PAGE_SIZE });
  }

  getFilteredFabrics(allFabrics) {
    var searchQuery = this.state.searchQuery;
    var filters = this.state.filters;
    var q = searchQuery.toLowerCase().trim();
    var showAdditional = this.state.showAdditionalFabrics;
    var activeArea = this.state.activeApplicationArea;

    return allFabrics.filter(function (f) {
      // Fabric entity: sku (SKU), descr (DESCR), collection (COLLECTION), grade (GRADE), category1 (CATEGORY1=patternGroup), hexclrgrp (HEXCLRGRP=colorGroup)
      if (showAdditional && activeArea && (f.sku === "COM" || f.sku === "COL")) return false;
      if (q && f.sku.toLowerCase().indexOf(q) === -1 && (f.descr || "").toLowerCase().indexOf(q) === -1) return false;
      if (filters.collection.length && filters.collection.indexOf(f.collection) === -1) return false;
      if (filters.grade.length && filters.grade.indexOf(f.grade) === -1) return false;
      if (filters.pattern.length && f.category1 && filters.pattern.indexOf(f.category1) === -1) return false;
      if (filters.color.length && f.hexclrgrp && filters.color.indexOf(f.hexclrgrp) === -1) return false;
      return true;
    });
  }

  getActiveFabricArea() {
    var config = this.getConfig();
    var fabricConfig = config.fabrics;
    if (!fabricConfig) return "Main";
    var areas = fabricConfig.applicationAreas || [];
    if (this.state.showAdditionalFabrics && this.state.activeApplicationArea) {
      return this.state.activeApplicationArea;
    }
    return areas.length > 0 ? areas[0] : "Main";
  }

  selectFabric(fabric) {
    var self = this;
    var area = this.getActiveFabricArea();
    this.setState(function (prev) {
      var selections = {};
      for (var k in prev.fabricSelections) selections[k] = prev.fabricSelections[k];
      selections[area] = fabric;
      self.saveSelections({ fabricSelections: selections });
      return { fabricSelections: selections };
    });
  }

  selectFinish(finish) {
    this.setState({ selectedFinish: finish });
    this.saveSelections({ selectedFinish: finish });
  }

  onCustomOptionSelect(optionName, value) {
    var self = this;
    this.setState(function (prev) {
      var opts = {};
      for (var k in prev.selectedOptions) opts[k] = prev.selectedOptions[k];
      opts[optionName] = value;
      self.saveSelections({ selectedOptions: opts });
      return { selectedOptions: opts };
    });
  }

  onAdditionalChange(key, value) {
    var self = this;
    this.setState(function (prev) {
      var opts = {};
      for (var k in prev.additionalOptions) opts[k] = prev.additionalOptions[k];
      opts[key] = value;
      self.saveSelections({ additionalOptions: opts });
      return { additionalOptions: opts };
    });
  }

  resetFabric() {
    var area = this.getActiveFabricArea();
    var self = this;
    this.setState(function (prev) {
      var selections = {};
      for (var k in prev.fabricSelections) selections[k] = prev.fabricSelections[k];
      delete selections[area];
      self.saveSelections({ fabricSelections: selections });
      return { fabricSelections: selections, searchQuery: "", searchShowCancel: false, filters: { collection: [], grade: [], pattern: [], color: [] }, showAdditionalFabrics: false, activeApplicationArea: null, fabricDisplayCount: 60 };
    });
  }

  resetFinish() {
    this.setState({ selectedFinish: null, searchQuery: "", searchShowCancel: false });
    this.saveSelections({ selectedFinish: null });
  }

  buildConfigurationItems() {
    var items = [];
    var sortOrder = 0;
    var config = this.getConfig();
    var baseImageUrl = this.props.baseImageUrl || "";

    // Fabric or Leather — one item per application area
    if (config.fabrics) {
      var fabricConfig = config.fabrics;
      var isLeather = fabricConfig.isLeather;
      var areas = fabricConfig.applicationAreas || [];
      var pillowAreas = fabricConfig.pillowApplicationAreas || [];
      var fabricSelections = this.state.fabricSelections || {};
      var mainArea = areas.length > 0 ? areas[0] : "Main";
      var mainSelection = fabricSelections[mainArea] || null;
      var allAreas = areas.concat(pillowAreas);
      var areasToEmit = allAreas.length > 0 ? allAreas : (mainSelection ? ["Main"] : []);

      for (var a = 0; a < areasToEmit.length; a++) {
        var area = areasToEmit[a];
        var f = fabricSelections[area] || mainSelection;
        if (!f) continue;
        var isPillowArea = pillowAreas.indexOf(area) !== -1;
        items.push({
          optionType: isLeather ? "Leather" : "Fabric",
          optionCode: isPillowArea ? "Pillow: " + area : area,
          selectedSku: f.sku,
          selectedName: f.descr || f.sku,
          image: (f.sku === "COM" || f.sku === "COL") ? "" : baseImageUrl + "/fabrics-leathers/thumbnail/" + toImagePath(f.imagepath),
          upcharge: 0,
          sortOrder: sortOrder++
        });
      }
    }

    // Finish
    if (this.state.selectedFinish) {
      var fin = this.state.selectedFinish;
      items.push({
        optionType: "Finish",
        optionCode: "",
        selectedSku: fin.sku || "",
        selectedName: fin.name || "",
        image: baseImageUrl + "/custom-options/" + fin.imageName,
        upcharge: 0,
        sortOrder: sortOrder++
      });
    }

    // Top-level custom options
    var options = (config.options || []);
    for (var i = 0; i < options.length; i++) {
      var opt = options[i];
      if (opt.isAdditionalOption) continue;
      var sel = this.state.selectedOptions[opt.name];
      if (sel) {
        items.push({
          optionType: opt.name,
          optionCode: "",
          selectedSku: sel.sku || "",
          selectedName: sel.name || "",
          image: baseImageUrl + "/custom-options/" + sel.imageName,
          upcharge: opt.upcharge || 0,
          sortOrder: sortOrder++
        });
      }
    }

    // Additional options
    for (var j = 0; j < options.length; j++) {
      var addOpt = options[j];
      if (!addOpt.isAdditionalOption) continue;
      var selectedSku = this.state.additionalOptions[addOpt.name];
      if (selectedSku) {
        var match = (addOpt.options || []).find(function (o) { return o.sku === selectedSku; });
        items.push({
          optionType: addOpt.name,
          optionCode: "",
          selectedSku: selectedSku,
          selectedName: match ? match.name : selectedSku,
          image: match ? baseImageUrl + "/custom-options/" + match.imageName : "",
          upcharge: addOpt.upcharge || 0,
          sortOrder: sortOrder++
        });
      }
    }

    return items;
  }

  confirmConfiguration() {
    var items = this.buildConfigurationItems();
    if (items.length === 0) return;

    this.saveSelections({ status: "Confirmed", items: items });
    this.setState({ confirmed: true });
  }

  addToQuoteRequest() {
    var self = this;
    var sku = this.props.sku;
    var quoteItem = {
      frameSku: sku,
      productName: this.props.productName || "",
      collection: this.props.collection || "",
      image: this.props.productImage || "",
      comments: "",
      fileUrls: [],
      quantity: 1,
      price: parseFloat(this.props.price) || 0,
      configurationItems: this.buildConfigurationItems()
    };

    if (!window.__isSignedIn) {
      // Save to sessionStorage and dispatch event for the login popup
      try {
        var pending = JSON.parse(sessionStorage.getItem("pending-quote-items") || "[]");
        var idx = -1;
        for (var i = 0; i < pending.length; i++) {
          if (pending[i].frameSku === sku) { idx = i; break; }
        }
        if (idx > -1) pending[idx] = quoteItem;
        else pending.push(quoteItem);
        sessionStorage.setItem("pending-quote-items", JSON.stringify(pending));
      } catch (e) { }
      // Also save configuration
      this.confirmConfiguration();
      self.close();
      // Dispatch event for the quote-request.js login popup
      document.dispatchEvent(new CustomEvent("quote-login-required", {
        detail: { productName: self.props.productName, image: self.props.productImage, sku: sku }
      }));
      return;
    }

    fetch("/api/Quote/AddItem", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify(quoteItem)
    })
    .then(function (res) {
      if (!res.ok) {
        if (res.status === 401 || res.status === 302) {
          throw new Error("Not authenticated");
        }
        return res.json().then(function (d) { throw d; });
      }
      return res.json();
    })
    .then(function (data) {
      if (data.success) {
        var qLabel = data.itemCount > 99 ? "99+" : String(data.itemCount);
        document.querySelectorAll(".quote-badge-count").forEach(function(badge){
          badge.textContent = qLabel;
          badge.style.display = data.itemCount > 0 ? "" : "none";
        });
        self.close();
        var toast = document.querySelector("paper-toast");
        if (toast) {
          toast.setAttribute("text", (self.props.productName || "Item") + " added to quote request.");
          toast.show();
        }
        try {
          document.dispatchEvent(new CustomEvent("quote-item-added", {
            detail: { quoteItem: quoteItem, itemCount: data.itemCount }
          }));
        } catch (ev) { }
      } else {
        var toast = document.querySelector("paper-toast");
        if (toast) {
          toast.setAttribute("text", data.message || "Error adding to quote.");
          toast.show();
        }
      }
    })
    .catch(function () {
      var toast = document.querySelector("paper-toast");
      if (toast) {
        toast.setAttribute("text", "Error adding to quote.");
        toast.show();
      }
    });
  }

  viewBuildSummary() {
    this.setState({ showSummary: true });
    if (this.tabContentRef) this.tabContentRef.scrollTop = 0;
    if (this.modalRef) this.modalRef.scrollTop = 0;
  }

  closeSummary() {
    this.setState({ showSummary: false });
  }

  renderBuildSummary() {
    var self = this;
    var items = this.buildConfigurationItems();
    var productName = this.props.productName;
    var sku = this.props.sku;
    var collection = this.props.collection;
    var productImage = this.props.productImage;

    return (
      <div className="configure-summary">
        <div className="configure-summary-header">
          <a className="configure-summary-back" onClick={() => this.closeSummary()}>&larr; Back to Configuration</a>
          <h4>Build Summary</h4>
        </div>
        <div className="configure-summary-product">
          {productImage && <img src={productImage} alt={productName} className="configure-summary-product-image" />}
          <div className="configure-summary-product-info">
            {collection && <span className="configure-summary-collection">{collection}</span>}
            <span className="configure-summary-product-name">{productName}</span>
            <span className="configure-summary-product-sku">{sku}</span>
          </div>
        </div>
        {items.length === 0 && (
          <div className="configure-empty">No selections have been made.</div>
        )}
        {items.length > 0 && (
          <div className="configure-summary-items">
            {items.map(function (item, idx) {
              return (
                <div className="configure-summary-item" key={idx}>
                  <div className="configure-summary-item-thumb">
                    {item.image
                      ? <SwatchImage src={item.image + "?width=500"} alt={item.selectedName} />
                      : <div className="configure-swatch-image configure-swatch-placeholder"><span>{item.selectedSku}</span></div>
                    }
                  </div>
                  <div className="configure-summary-item-info">
                    <span className="configure-summary-item-type">{item.optionType}{item.optionCode ? " — " + item.optionCode : ""}</span>
                    <span className="configure-summary-item-name">{item.selectedName}</span>
                    <span className="configure-summary-item-sku">SKU: {item.selectedSku}</span>
                  </div>
                  {item.upcharge > 0 && (
                    <div className="configure-summary-item-upcharge">+${item.upcharge}</div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    );
  }

  renderSearchBar(placeholder) {
    var searchQuery = this.state.searchQuery;
    var cancelCls = "gallery-search-cancel" + (this.state.searchShowCancel ? " visible" : "");
    return (
      <div className="gallery-search-bar configure-search-bar">
        <div className="gallery-search-input">
          <div className="gallery-search-input-inner">
            <img src="/images/icons/search-icon.png" className="search-icon-g-2" />
            <div className="gallery-search-input-field configure-search-field">
              <input
                type="text"
                placeholder={placeholder}
                value={searchQuery}
                onChange={(e) => this.onSearchChange(e)}
              />
            </div>
            <span className={cancelCls} onClick={() => this.onSearchCancel()}>x</span>
          </div>
        </div>
      </div>
    );
  }

  renderComColPlaceholder(label) {
    return (
      <div className="configure-swatch-image configure-swatch-placeholder">
        <span>{label}</span>
      </div>
    );
  }

  renderFabricTab() {
    var self = this;
    var config = this.getConfig();
    var fabricConfig = config.fabrics;
    if (!fabricConfig) return null;

    var allFabrics = fabricConfig.options || [];
    var allFiltered = this.getFilteredFabrics(allFabrics);
    var fabrics = allFiltered.slice(0, this.state.fabricDisplayCount);
    var hasMore = fabrics.length < allFiltered.length;
    var filters = this.state.filters;
    var currentArea = this.getActiveFabricArea();
    var fabricSelections = this.state.fabricSelections || {};
    var selectedFabric = fabricSelections[currentArea] || null;
    var showAdditionalFabrics = this.state.showAdditionalFabrics;
    var applicationAreas = fabricConfig.applicationAreas || [];
    var pillowAreas = fabricConfig.pillowApplicationAreas || [];
    var hasAnyAreas = applicationAreas.length > 0 || pillowAreas.length > 0;
    var activeArea = this.state.activeApplicationArea;
    var fabricFilters = fabricConfig.fabricFilters || {};
    var baseImageUrl = this.props.baseImageUrl || "";
    var isLeather = fabricConfig.isLeather;
    var toggleLabel = isLeather ? "Leather" : "Fabric";

    var collections = filterBlank(fabricFilters.collections).map(function (v) { return { value: v, label: v }; });
    var grades = filterBlank(fabricFilters.grades).map(function (v) { return { value: v, label: v }; });
    var patterns = filterBlank(fabricFilters.patterns).map(function (v) { return { value: v, label: v }; });
    var colors = filterBlank(fabricFilters.colors).map(function (v) { return { value: v, label: v }; });
    var chips = this.getSelectedChips();

    return (
      <div className="configure-tab-panel">
        {hasAnyAreas && (
          <div className="configure-fabric-toggle">
            <a onClick={() => this.setState({ showAdditionalFabrics: !showAdditionalFabrics, activeApplicationArea: showAdditionalFabrics ? null : (applicationAreas[0] || pillowAreas[0] || null) })}>
              {showAdditionalFabrics ? "Hide" : "Show"} Additional {toggleLabel} Options
            </a>
          </div>
        )}

        {showAdditionalFabrics && hasAnyAreas && (
          <div className="configure-application-areas-wrapper">
            {applicationAreas.length > 0 && (
              <div className="configure-application-areas">
                {applicationAreas.map(function (area) {
                  return (
                    <button
                      key={area}
                      className={"configure-area-tab" + (activeArea === area ? " active" : "")}
                      onClick={function () { self.setState({ activeApplicationArea: area }); }}
                    >
                      {area}
                    </button>
                  );
                })}
              </div>
            )}
            {pillowAreas.length > 0 && (
              <div className="configure-application-areas-group">
                <span className="configure-area-group-label">Pillow Upholstery</span>
                <div className="configure-application-areas">
                  {pillowAreas.map(function (area) {
                    return (
                      <button
                        key={area}
                        className={"configure-area-tab" + (activeArea === area ? " active" : "")}
                        onClick={function () { self.setState({ activeApplicationArea: area }); }}
                      >
                        {area}
                      </button>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        )}

        <div className="configure-toolbar">
          {this.renderSearchBar("Enter a " + toggleLabel + " SKU or Name")}

          <span
            className="configure-mobile-filter-trigger"
            onClick={this.openMobileFilter}
          >
            Filter
          </span>

          <div className={"configure-filter-panel" + (this.state.mobileFilterOpen ? " mobile-open" : "")}>
            <div className="configure-mobile-filter-header">
              <span className="configure-mobile-filter-title">Filters</span>
              <button
                type="button"
                className="configure-mobile-filter-close"
                onClick={this.closeMobileFilter}
              >&times;</button>
            </div>
            <div className="ff-filter-bar configure-filter-bar">
              <FilterDropdown label="Collection">
                {function (bag) {
                  return (
                    <MaterialMenuTwo
                      options={collections}
                      selectedValues={filters.collection}
                      onToggle={function (v) { self.toggleFilterValue("collection", v); }}
                    />
                  );
                }}
              </FilterDropdown>
              <FilterDropdown label="Grade">
                {function (bag) {
                  return (
                    <MaterialMenuFour
                      options={grades}
                      selectedValues={filters.grade}
                      onToggle={function (v) { self.toggleFilterValue("grade", v); }}
                    />
                  );
                }}
              </FilterDropdown>
              <FilterDropdown label="Pattern">
                {function (bag) {
                  return (
                    <MaterialMenuTwo
                      options={patterns}
                      selectedValues={filters.pattern}
                      onToggle={function (v) { self.toggleFilterValue("pattern", v); }}
                    />
                  );
                }}
              </FilterDropdown>
              <FilterDropdown label="Color">
                {function (bag) {
                  return (
                    <MaterialMenuTwo
                      options={colors}
                      selectedValues={filters.color}
                      onToggle={function (v) { self.toggleFilterValue("color", v); }}
                    />
                  );
                }}
              </FilterDropdown>
            </div>
            <div className="configure-mobile-filter-footer">
              <button
                type="button"
                className="configure-mobile-filter-apply"
                onClick={this.closeMobileFilter}
              >APPLY</button>
            </div>
          </div>
          {this.state.mobileFilterOpen && (
            <div className="configure-mobile-filter-overlay" onClick={this.closeMobileFilter}></div>
          )}
        </div>

        <SelectedFilters
          items={chips}
          onRemove={(chip) => this.removeChip(chip)}
          onClearAll={() => this.clearAllFilters()}
        />

        <div className="configure-swatch-grid">
          {fabrics.map(function (f) {
            var isPlaceholder = f.sku === "COM" || f.sku === "COL";
            var imgPath = toImagePath(f.imagepath);
            return (
              <div
                key={f.sku + "-" + f.id}
                className={"configure-swatch" + (selectedFabric && selectedFabric.sku === f.sku && selectedFabric.id === f.id ? " selected" : "")}
                onClick={function () { self.selectFabric(f); }}
              >
                {isPlaceholder
                  ? self.renderComColPlaceholder(f.sku)
                  : <SwatchImage src={baseImageUrl + "/fabrics-leathers/thumbnail/" + imgPath} alt={f.descr} />
                }
                <div className="configure-swatch-label">{f.sku} - {f.descr}</div>
              </div>
            );
          })}
          {fabrics.length === 0 && (
            <div className="configure-empty">No {toggleLabel.toLowerCase()}s match your criteria</div>
          )}
        </div>
        {hasMore && (
          <div className="configure-load-more">Showing {fabrics.length} of {allFiltered.length}</div>
        )}
        {selectedFabric && (
          <div className="configure-bottom-bar">
            <div className="configure-bottom-bar-selection">
              {(selectedFabric.sku === "COM" || selectedFabric.sku === "COL")
                ? <div className="configure-bottom-bar-thumb configure-swatch-placeholder"><span>{selectedFabric.sku}</span></div>
                : <div className="configure-bottom-bar-thumb">
                    <img src={baseImageUrl + "/fabrics-leathers/thumbnail/" + toImagePath(selectedFabric.imagepath)} alt={selectedFabric.descr} />
                  </div>
              }
              <div className="configure-bottom-bar-info">
                <span className="configure-bottom-bar-name">{selectedFabric.descr}</span>
                <span className="configure-bottom-bar-detail">
                  {currentArea && currentArea !== "Main" ? currentArea + " | " : ""}
                  {selectedFabric.collection && "Collection: " + selectedFabric.collection}
                  {selectedFabric.grade && " | Grade: " + selectedFabric.grade}
                </span>
              </div>
              {selectedFabric.sku !== "COM" && selectedFabric.sku !== "COL" && (
                <a className="configure-bottom-bar-link" href={"/Custom-Option/" + (isLeather ? "Leather" : "Fabric") + "/All/Detail/" + encodeURIComponent(selectedFabric.descr || selectedFabric.sku) + "/" + selectedFabric.sku} target="_self">More Details</a>
              )}
            </div>
            <div className="configure-bottom-bar-actions">
              <button className="ui-button-configure ink" onClick={() => this.selectFabric(selectedFabric)}>Save Selection</button>
              <button className="ui-button-configure ink" onClick={() => this.resetFabric()}>Reset to Default</button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderFinishTab() {
    var self = this;
    var config = this.getConfig();
    var finishConfig = config.finishes;
    if (!finishConfig) return null;

    var allFinishes = finishConfig.options || [];
    var searchQuery = this.state.searchQuery;
    var q = searchQuery.toLowerCase().trim();
    var selectedFinish = this.state.selectedFinish;
    var baseImageUrl = this.props.baseImageUrl || "";

    // CustomOption entity: sku (SKU), name (Name), imageName (ImageName)
    var finishes = allFinishes.filter(function (f) {
      if (q && (f.sku || "").toLowerCase().indexOf(q) === -1 && (f.name || "").toLowerCase().indexOf(q) === -1) return false;
      return true;
    });

    return (
      <div className="configure-tab-panel">
        {this.renderSearchBar("Enter a Finish SKU or Name")}

        <div className="configure-swatch-grid">
          {finishes.map(function (f) {
            return (
              <div
                key={f.id}
                className={"configure-swatch" + (selectedFinish && selectedFinish.id === f.id ? " selected" : "")}
                onClick={function () { self.selectFinish(f); }}
              >
                <SwatchImage src={baseImageUrl + "/custom-options/" + f.imageName + "?width=500"} alt={f.name} />
                <div className="configure-swatch-label">{f.sku} - {f.name}</div>
              </div>
            );
          })}
          {finishes.length === 0 && (
            <div className="configure-empty">No finishes match your criteria</div>
          )}
        </div>
        {selectedFinish && (
          <div className="configure-bottom-bar">
            <div className="configure-bottom-bar-selection">
              <div className="configure-bottom-bar-thumb">
                <img src={baseImageUrl + "/custom-options/" + selectedFinish.imageName + "?width=500"} alt={selectedFinish.name} onError={function(e){ e.target.style.display='none'; }} />
              </div>
              <div className="configure-bottom-bar-info">
                <span className="configure-bottom-bar-name">{selectedFinish.name}</span>
                <span className="configure-bottom-bar-detail">SKU: {selectedFinish.sku}</span>
              </div>
              <a className="configure-bottom-bar-link" href={"/Custom-Option/Finish/Detail/" + encodeURIComponent(selectedFinish.sku)} target="_self">More Details</a>
            </div>
            <div className="configure-bottom-bar-actions">
              <button className="ui-button-configure ink" onClick={() => this.selectFinish(selectedFinish)}>Save Selection</button>
              <button className="ui-button-configure ink" onClick={() => this.resetFinish()}>Reset to Default</button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderCustomOptionTab(option, optionIndex) {
    var self = this;
    var subGroups = option.subGroups || [];
    var applicationAreas = option.applicationAreas || [];
    var hasSubGroups = subGroups.length > 0;
    var searchQuery = this.state.searchQuery;
    var q = searchQuery.toLowerCase().trim();
    var selectedItem = this.state.selectedOptions[option.name];
    var baseImageUrl = this.props.baseImageUrl || "";

    var filterItems = function (items) {
      return (items || []).filter(function (f) {
        if (q && (f.sku || "").toLowerCase().indexOf(q) === -1 && (f.name || "").toLowerCase().indexOf(q) === -1) return false;
        return true;
      });
    };

    var renderSwatch = function (f) {
      return (
        <div
          key={f.id}
          className={"configure-swatch" + (selectedItem && selectedItem.id === f.id ? " selected" : "")}
          onClick={function () { self.onCustomOptionSelect(option.name, f); }}
        >
          <SwatchImage src={baseImageUrl + "/custom-options/" + f.imageName + "?width=500"} alt={f.name} />
          <div className="configure-swatch-label">{f.sku} - {f.name}</div>
        </div>
      );
    };

    return (
      <div className="configure-tab-panel">
        {this.renderSearchBar("Search " + option.name)}

        {applicationAreas.length > 0 && (
          <div className="configure-application-area">
            <strong>Application:</strong> {applicationAreas.join(", ")}
          </div>
        )}

        {hasSubGroups ? (
          subGroups.map(function (group, gi) {
            var filtered = filterItems(group.options);
            if (filtered.length === 0) return null;
            return (
              <div key={gi} className="configure-subgroup">
                <h4 className="configure-subgroup-label">{group.label}</h4>
                <div className="configure-swatch-grid">
                  {filtered.map(renderSwatch)}
                </div>
              </div>
            );
          })
        ) : (
          <div className="configure-swatch-grid">
            {filterItems(option.options).map(renderSwatch)}
            {filterItems(option.options).length === 0 && (
              <div className="configure-empty">No options match your criteria</div>
            )}
          </div>
        )}

        {selectedItem && (
          <div className="configure-bottom-bar">
            <div className="configure-bottom-bar-selection">
              <div className="configure-bottom-bar-thumb">
                <img src={baseImageUrl + "/custom-options/" + selectedItem.imageName + "?width=500"} alt={selectedItem.name} onError={function(e){ e.target.style.display='none'; }} />
              </div>
              <div className="configure-bottom-bar-info">
                <span className="configure-bottom-bar-name">{selectedItem.name}</span>
                <span className="configure-bottom-bar-detail">SKU: {selectedItem.sku}</span>
              </div>
            </div>
            <div className="configure-bottom-bar-actions">
              <button className="ui-button-configure ink" onClick={() => this.onCustomOptionSelect(option.name, selectedItem)}>Save Selection</button>
              <button className="ui-button-configure ink" onClick={() => this.onCustomOptionSelect(option.name, null)}>Reset</button>
            </div>
          </div>
        )}
      </div>
    );
  }

  renderAdditionalTab() {
    var self = this;
    var config = this.getConfig();
    var options = config.options || [];
    var additionalOptions = options.filter(function (o) { return o.isAdditionalOption; });
    var selectedValues = this.state.additionalOptions;

    return (
      <div className="configure-tab-panel">
        {additionalOptions.map(function (opt) {
          var items = opt.options || [];
          return (
            <div className="configure-additional-row" key={opt.name}>
              <label>{opt.name}</label>
              <select
                value={selectedValues[opt.name] || ""}
                onChange={function (e) { self.onAdditionalChange(opt.name, e.target.value); }}
              >
                <option value="">Select...</option>
                {items.map(function (item) {
                  return <option key={item.id} value={item.sku}>{item.name}</option>;
                })}
              </select>
            </div>
          );
        })}
      </div>
    );
  }

  renderSidebarProduct() {
    var productName = this.props.productName;
    var collection = this.props.collection;
    var price = this.props.price;
    var availability = this.props.availability;
    var productImage = this.props.productImage;
    return (
      <div className="configure-sidebar-product">
        {collection && <div className="configure-sidebar-collection">{collection}</div>}
        <div className="configure-sidebar-name">{productName}</div>
        {price && this.props.isSignedIn && <div className="configure-sidebar-price">From: {price}</div>}
        {availability && <div className="configure-sidebar-availability">{availability}</div>}
        {productImage && <img src={productImage} alt={productName} className="configure-sidebar-image" />}
      </div>
    );
  }

  renderSidebarActions() {
    var confirmed = this.state.confirmed;
    return (
      <div className="configure-sidebar-actions">
        {confirmed ? (
          <button className="configure-btn-confirm ink" onClick={() => this.addToQuoteRequest()}>
            Add To Quote Request
          </button>
        ) : (
          <button className="configure-btn-confirm ink" onClick={() => this.confirmConfiguration()}>
            Confirm Configuration
          </button>
        )}
        <button className="configure-btn-summary ink" onClick={() => this.viewBuildSummary()}>
          View Build Summary
        </button>
      </div>
    );
  }

  renderTabContent() {
    if (this.state.showSummary) return this.renderBuildSummary();

    var activeTab = this.state.activeTab;
    var config = this.getConfig();
    var options = config.options || [];

    if (activeTab === "fabric") return this.renderFabricTab();
    if (activeTab === "finish") return this.renderFinishTab();
    if (activeTab === "additional") return this.renderAdditionalTab();

    if (activeTab.indexOf("custom-") === 0) {
      var idx = parseInt(activeTab.replace("custom-", ""), 10);
      var option = options[idx];
      if (option) return this.renderCustomOptionTab(option, idx);
    }

    return null;
  }

  renderLoadingState() {
    var body;
    if (this.state.configError) {
      body = (
        <div className="configure-loading">
          <p>Unable to load configuration options. Please try again.</p>
          <button className="ui-button secondary min-width ink" onClick={() => this.loadConfiguration()}>Retry</button>
        </div>
      );
    } else {
      body = (
        <div className="configure-loading">
          <p>Loading configuration options&hellip;</p>
        </div>
      );
    }
    return (
      <div className="configure-overlay" onClick={this.onOverlayClick}>
        <div className="configure-modal">
          <div className="configure-header">
            <h3>Configuration Options</h3>
            <button className="configure-close" onClick={this.close}>&times;</button>
          </div>
          <div className="configure-body">{body}</div>
        </div>
      </div>
    );
  }

  render() {
    if (!this.state.visible) return null;
    if (!this.state.config) return this.renderLoadingState();
    var config = this.getConfig();
    var tabs = this.buildTabs(config);
    var activeTab = this.state.activeTab;

    return (
      <div className="configure-overlay" onClick={this.onOverlayClick}>
        <div className="configure-modal" ref={(el) => { this.modalRef = el; }} onScroll={this.onTabContentScroll}>
          <div className="configure-header">
            <h3>Configuration Options</h3>
            <button className="configure-close" onClick={this.close}>&times;</button>
          </div>
          <div className="configure-body">
            <div className="configure-content">
              <div className="configure-tabs">
                {tabs.map(function (tab) {
                  return (
                    <button
                      key={tab.key}
                      className={"configure-tab" + (activeTab === tab.key ? " active" : "")}
                      onClick={() => this.setTab(tab.key)}
                    >
                      {tab.label}
                    </button>
                  );
                }.bind(this))}
              </div>
              <div className="configure-tab-content" ref={(el) => { this.tabContentRef = el; }} onScroll={this.onTabContentScroll}>
                {this.renderTabContent()}
              </div>
            </div>
            <div className="configure-sidebar">
              {this.renderSidebarProduct()}
              {this.renderSidebarActions()}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
